import { render } from "./InputsRadioGroups.vue?vue&type=template&id=35b79527"
import script from "./InputsRadioGroups.vue?vue&type=script&lang=js"
export * from "./InputsRadioGroups.vue?vue&type=script&lang=js"

import "./InputsRadioGroups.vue?vue&type=style&index=0&id=35b79527&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__